import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { fetchTopicFailure, fetchTopicSuccess } from "entities/topics/actions";
import type { FetchTopicDefaultAction } from "entities/topics/actionTypes";
import type { Topic } from "entities/topics/types";

export function* fetchTopicSaga({ payload }: FetchTopicDefaultAction) {
  try {
    const topic: Topic = yield apiFetch(`map/${payload.id}`);
    yield put(fetchTopicSuccess({ topic }));
  } catch {
    yield put(fetchTopicFailure(payload.id, { logoutOnAuthError: true }));
  }
}
